<template>
    <div>
        <div class="mb-2">
            <label class="form-label">Type de prestation</label>
            <select class="form-select" aria-label="Default select example" v-model="this.type" id="type" name="type">
                <option :value="1">Solo</option>
                <option :value="2">Duo</option>
                <option :value="3">Trio</option>
                <option :value="-1">Publique</option>
            </select>
        </div>
        <div class="mb-2">
            <label class="form-label">Établissement</label>
            <select id="establishment" v-model="this.establishment_selected" name="establishment" class="form-select">
                <option v-for="(item, i) in JSON.parse(establishments)" :value="item.id" :key="i">
                    {{ item.name }}
                </option>
            </select>
        </div>
        <!-- <p>{{ type }}</p> -->
        <div class="mb-2">
            <label class="form-label">Salles</label>
            <select
                class="form-select js-example-basic-multiple"
                v-model="this.selectedSpace"
                id="space"
                name="space[]"
                style="width: 100%"
                data-placeholder="Salle 1 / Salle 2 ..."
                multiple=""
                data-select2-id="space"
                tabindex="-1"
                aria-hidden="true"
            >
                <option
                    :value="item.id"
                    v-for="(item, i) in JSON.parse(this.spaces)"
                    :key="i"
                    :selected="old_space.includes(item.id)"
                >
                    {{ item.name }}
                </option>
            </select>
        </div>
        <div class="mb-2">
            <label class="form-label">Praticienne(s)</label>
            <select
                v-model="this.selectedStaff"
                id="staff"
                name="staff[]"
                style="width: 100%"
                multiple=""
                tabindex="-1"
                aria-hidden="true"
            >
                <option :value="item.id" v-for="(item, i) in staffs" :key="i">{{ item.first_name }}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: ['establishments', 'spaces', 'old_type', 'old_esta', 'old_space', 'old_staff'],
    name: 'prestation',
    mounted() {
        //
        this.selectStaff(1)
        // this.selectSpaces(1);
        if (this.old_type) {
            this.type = this.old_type
        }
        if (this.old_esta) {
            this.establishment_selected = this.old_esta
        }
        if (this.old_space) {
            this.selectedSpace = JSON.parse(this.old_space)
        }
        if (this.old_staff) {
            this.selectedStaff = JSON.parse(this.old_staff)
        }
    },
    data: () => ({
        establishment_selected: 1,
        type: 1,
        staffs: {},
        selectedStaff: [],
        selectedSpace: [],
    }),
    methods: {
        selectType(event) {
            this.type = event.target.value
            this.selectSpaces(this.establishment_selected)
        },
        selectEsta(event) {
            this.establishment_selected = event.target.value
            this.selectSpaces(this.establishment_selected)
            this.selectStaff(this.establishment_selected)
        },
        async selectSpaces(id) {
            axios
                .post(`/back-office/prestations/${id}/spaces`, {
                    type: this.type,
                })
                .then((response) => {
                    this.spaces = JSON.stringify(response.data)
                })
        },

        async selectStaff(id) {
            axios.get(`/back-office/prestations/${id}/get/staffs/establishment`).then((response) => {
                this.staffs = JSON.stringify(response.data)
                //  console.log(this.staffs)
            })
        },
    },
}
</script>
